import { Typography } from '@material-ui/core';
import React from 'react'
import useStyles from './style';

interface Props {
  inline?: boolean;
  text?: string;
}

export default function ({ inline, text }: Props) {
  const classes = useStyles({inline});
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <span className={[classes.dot, 'animation-wave'].join(' ')} />
        <span className={[classes.dot, 'animation-wave'].join(' ')} />
        <span className={[classes.dot, 'animation-wave'].join(' ')} />
      </div>
      {text && <Typography className={classes.text}>{text}</Typography>}
    </div>
  );
}
